export const buildUrlQuery = (query: Record<string, string | number | boolean | null | undefined>) => {
    return Object.entries(query)
        .filter(([, value]) => value !== undefined && value !== null && value !== "") // remove undefined & null
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
        .join("&");
};
